import React, { useMemo } from 'react'
import { listTablePrefs, allKey } from 'app/constants'
import { listImportedClusters } from 'app/plugins/infrastructure/components/importedClusters/new-actions'
import { projectAs } from 'utils/fp'
import { useSelector } from 'react-redux'
import { prop, uniqBy, pick } from 'ramda'
import { createUsePrefParamsHook } from 'core/hooks/useParams'
import { importedClustersSelector } from 'app/plugins/infrastructure/components/importedClusters/selectors'
import useListAction from 'core/hooks/useListAction'
import useReactRouter from 'use-react-router'
import createCRUDComponents from 'core/helpers/createCRUDComponents'
import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'

const columns = [
  { id: 'agentPoolName', label: 'Node Pool' },
  { id: 'name', label: 'Node Name' },
  { id: 'location', label: 'Location' },
  { id: 'sku.name', label: 'SKU' },
  { id: 'sku.tier', label: 'Tier' },
  { id: 'vmId', label: 'VM ID' },
]

const defaultParams = {
  agentPoolName: allKey,
}
const usePrefParams = createUsePrefParamsHook('DeployedApps', listTablePrefs)

const ListPage = ({ ListContainer }) => {
  return () => {
    const { params, getParamsUpdater } = usePrefParams(defaultParams)
    const { match } = useReactRouter()
    const { loading, reload } = useListAction(listImportedClusters)
    const clusters = useSelector(importedClustersSelector)
    const cluster = clusters.find((x) => x.uuid === match.params.id)

    const {
      spec: {
        aks: { instances: nodes = [] },
      },
    } = cluster

    const options = useMemo(
      () =>
        projectAs(
          { label: 'agentPoolName', value: 'agentPoolName' },
          uniqBy(prop('agentPoolName'), nodes),
        ),
      [nodes],
    )

    const filteredNodes = nodes.filter((node) => {
      if (params.agentPoolName === allKey) {
        return true
      } else {
        return params.agentPoolName === node.agentPoolName
      }
    })
    return (
      <ListContainer
        loading={loading}
        reload={reload}
        data={filteredNodes}
        getParamsUpdater={getParamsUpdater}
        filters={
          <>
            <AsyncDropdown
              label="Node Pool"
              onChange={getParamsUpdater('agentPoolName')}
              value={params.agentPoolName}
              items={options}
            />
          </>
        }
        {...pick(listTablePrefs, params)}
      />
    )
  }
}

export const options = {
  columns,
  uniqueIdentifier: 'vmId',
  multiSelection: false,
  showBreadcrumbs: false,
  name: 'AKSNodes',
  ListPage,
}

const components = createCRUDComponents(options)

export default components.ListPage
